import React from "react";

const clients = [
  { name: "", logo: "/assets/logos/Screen.png" },
  { name: "", logo: "/assets/logos/layman.png" },
  { name: "", logo: "/assets/logos/jobs.png" },
  { name: "", logo: "/assets/logos/heli.png" },
  { name: "", logo: "/assets/logos/lofe.png" },
  { name: "", logo: "/assets/logos/ebytlas.png" },
  { name: "", logo: "/assets/logos/xlsintelligences.png" },
  { name: "", logo: "/assets/logos/ecomm.png" },  
  { name: "", logo: "/assets/logos/bytlas.png" },  
{ name: "", logo: "/assets/logos/srabhang.png" },
{ name: "", logo: "/assets/logos/bytlas-academy.png" },
{ name: "", logo: "/assets/logos/bytlas-flix.png" }
];

export default function Clients() {
  return (
    <section className="clients-section py-4 bg-light">
      <h2 className="text-center mb-4">Driving Digital Excellence for <span className="text-primary fw-bold">Market Leaders</span></h2>
      <div className="marquee-container">
        <div className="marquee">
          {clients.map((client, index) => (
            <div className="client-item text-center mx-4" key={index}>
              <img
                src={client.logo}
                alt={client.name}
                className="client-logo mb-3"
              />
              <div className="client-name small text-muted">{client.name}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}


